import { useEffect, useState } from 'react';

export const useCurrentHotel = () => {
  const [currentHotel, setCurrentHotel] = useState(
    window.optima?.user?.CurrentHotel
  );

  useEffect(() => {
    setCurrentHotel(window.optima?.user?.CurrentHotel);
  }, [window.optima?.user?.CurrentHotel]);

  return currentHotel;
};
